export const PARAM_GROUP = {
  FEDERAL_UNIT: 'FEDERAL_UNIT',
  ECONOMIC_ACTIVITY: 'ECONOMIC_ACTIVITY',
};

export const QUOTATION_STATUS = {
  PENDING: 'PE',
  PROPOSAL: 'PR',
  POLICY: 'PO',
};

export const PLANS = {
  BASIC: {
    code: 'BASIC',
    articoCode: 'PLANO_BASICO',
    catalogueCode: 'PB',
    frontName: 'Básico',
  },
  INTERMEDIATE: {
    code: 'INTERMEDIATE',
    articoCode: 'PLANO_INTERMEDIARIO',
    catalogueCode: 'PI',
    frontName: 'Platinum',
  },
  COMPLETE: {
    code: 'ALL_RISK',
    articoCode: 'PLANO_ALL_RISK',
    catalogueCode: 'PC',
    frontName: 'All Risk',
  },
  ALL_RISK: {
    code: 'ALL_RISK',
    articoCode: 'PLANO_ALL_RISK',
    catalogueCode: 'PC',
    frontName: 'All Risk',
  },
};

export const IOF = 0.0738;
export const POLICY_VALIDITY_DAYS = 365;
export const PROPOSAL_EXPIRATION_DAYS = 15;
export const COMMISSION_LIMIT = 30;

export const AGGREGATION_TYPES = {
  NONE: {
    code: 'NON',
    name: 'Nenhum',
  },
  AGGREGATION: {
    code: 'AGG',
    name: 'Agravar',
  },
  DISCOUNT: {
    code: 'DIS',
    name: 'Desconto',
  },
};

export const USER_GROUPS = {
  REGULAR: 'PROPERTYBR-BASE',
  ADVISER: 'ARTICO-BR-PROPERTY-ASESOR',
  BROKER: 'ARTICO-BR-PROPERTY-CORREDOR',
  COMERCIAL: 'ARTICO-BR-PROPERTY-COMERCIAL',
};
